import { httpClient } from '../../../services'

export function getRoleList (params) {
  return httpClient.get('/tools/v1/pregnant/categories', { params })
}

export function getArticleList (params) {
  return httpClient.get('/tools/v1/pregnant/articles', { params })
}

export function postToogleStatus (data) {
  return httpClient.post('/tools/v1/pregnant/save', data)
}

